import { differenceInSeconds, format, parseISO } from 'date-fns';

import { EventListItem } from '../types/events.types';
import { EventStatus } from 'routes/referral/types/event-detail-api.types';

export const eventFormatParticipantCount = (count: number): string => {
  if (count < 1000) {
    return count.toString();
  }
  const thousands = count / 1000;
  const formatted = thousands.toFixed(2);
  return `${parseFloat(formatted)}k`;
};

export const eventFormatTimeDifference = (targetDate: Date): string => {
  const now = new Date();

  if (targetDate <= now) {
    return '0S';
  }

  const totalSeconds = differenceInSeconds(targetDate, now);
  const days = Math.floor(totalSeconds / (24 * 60 * 60));
  const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
  const seconds = totalSeconds % 60;

  const parts: string[] = [];
  if (days > 0) parts.push(`${days}D`);
  if (hours > 0) parts.push(`${hours}H`);
  if (minutes > 0 || days > 0 || hours > 0) {
    parts.push(`${minutes}M`);
  } else if (seconds > 0) {
    parts.push(`${seconds}S`);
  }

  return parts.join(' ') || '0S';
};

export const eventFormatEndDate = (dateString: string): string => {
  const date = parseISO(dateString);
  return format(date, 'd MMMM').toUpperCase();
};

export const eventFormatDate = (event: EventListItem): string => {
  const status = event.status as EventStatus;

  switch (status) {
    case EventStatus.UPCOMING:
      return `starts in: ${eventFormatTimeDifference(parseISO(event.start_datetime))}`;
    case EventStatus.ONGOING:
      return `ends in: ${eventFormatTimeDifference(parseISO(event.end_datetime))}`;
    case EventStatus.FINISHED:
    case EventStatus.REWARDS_DISTRIBUTED:
      return `ended: ${eventFormatEndDate(event.end_datetime)}`;
    case EventStatus.REGISTRATION_OPEN:
      return `registration ends: ${eventFormatEndDate(event.registration_end_datetime)}`;
    default:
      return '';
  }
};

export const formatDateRange = (startDate: string, endDate: string): string => {
  const start = format(parseISO(startDate), 'dd.MM.yyyy');
  const end = format(parseISO(endDate), 'dd.MM.yyyy');
  return `${start} - ${end}`;
};
